import { Injectable } from '@angular/core';
import { ApiService } from '@/pages/service/core/api.service';

@Injectable({ providedIn: 'root' })
export class TeamService {

  constructor(private api: ApiService) {}

  addEmployee(payload: { email: string; name: string; phone?: string; roles: string[]; password?: string; employeeCode?: string; departmentIds?: string[] }) {
    return this.api.post('/company/employees', payload);
  }

  /** Update an existing member (name/phone/roles/employeeCode + optional departments). */
  updateEmployee(id: string, payload: { name?: string; phone?: string; roles?: string[]; employeeCode?: string; departmentIds?: string[] }) {
    return this.api.put('/company/employees/' + id, payload);
  }

  /**
   * Bulk-create members from a filled-in CSV file. Returns a per-row summary
   * { total, created, failed, errors[], warnings[] }. Sent as multipart; the
   * encryption interceptor handles the file bytes when encryption is on.
   */
  bulkUploadEmployees(file: File) {
    const fd = new FormData();
    fd.append('file', file);
    return this.api.post<any>('/company/employees/bulk-csv', fd);
  }

  getEmployees() {
    return this.api.get<any[]>('/company/employees');
  }

  /** The signed-in user's own profile (name, email, phone, employeeCode, roles). */
  getMyProfile() {
    return this.api.get<any>('/company/employees/me');
  }

  /** Soft-remove a team member (deactivates the account; they can be re-added later). */
  deleteEmployee(id: string) {
    return this.api.delete('/company/employees/' + id);
  }

  /** Admin sets a new password for a user (they can sign in with it directly). */
  resetUserPassword(id: string, password: string) {
    return this.api.post('/company/employees/' + id + '/password', { password });
  }

  /** Delete a whole team (and its members / groups / phase mappings). */
  deleteTeam(teamId: string) {
    return this.api.delete('/api/teams/' + teamId);
  }

  /** Remove one member (team_members row) from a team — does NOT delete the user. */
  removeTeamMember(teamId: string, memberId: string) {
    return this.api.delete('/api/teams/' + teamId + '/members/' + memberId);
  }
}
